<template>
    <div class="buy-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/vip' }">开通VIP</el-breadcrumb-item>
            <el-breadcrumb-item>VIP购买</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="buy-box-content">
            <h3>购买内容</h3>
            <el-row class="buy-vip-infor">
                <el-col :span="6">
                    <img :src="vipInfor.image" alt="志愿卡" v-if="vipInfor.image">
                    <img src="../../assets/images/zyk.png" alt="志愿卡" v-else>
                </el-col>
                <el-col :span="18">
                    <el-row>
                        <el-col :span="20" class="buy-vip-title">
                            {{vipInfor.title[0]}}<span :class="vipInfor.title[1] == 'SVIP'?'buy-vip-title-diff':''">{{vipInfor.title[1]}}</span>{{vipInfor.title[2]}}
                        </el-col>
                        <el-col :span="4" class="buy-vip-money">
                            <span>¥</span>{{vipInfor.present_price}}
                        </el-col>
                    </el-row>
                    <el-row class="buy-vip-desc">
                        <el-col>
                            <span>适用学生：</span>普通类文理科考生
                        </el-col>
                        <el-col>
                            <span>使用范围：</span>仅限河南、四川考生本人使用
                        </el-col>
                        <el-col v-if="vipInfor.is_choose_year == '0'">
                            <span>截止时间：</span>{{default_year + '/9/1 23:59:59'}}
                        </el-col>
                    </el-row>
                </el-col>   
            </el-row>
            <!-- <h3 v-if="vipInfor.is_choose_year == '1'">高考年份</h3>
            <el-row class="buy-form" v-if="vipInfor.is_choose_year == '1'">
                <el-row>
                    <el-col :span="9">
                        <el-form :model="ruleForm" ref="ruleForm">
                            <el-form-item prop="exam_year">
                                <el-select v-model="ruleForm.exam_year" placeholder="请选择您的高考年份">
                                    <el-option
                                    v-for="item in yearList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="15" v-if="ruleForm.exam_year">
                        <el-row class="buy-desc">有效期至：</el-row>
                        <el-row class="buy-date">{{ruleForm.exam_year}}/9/1 23:59:59</el-row>
                    </el-col>
                </el-row>
                <el-row class="buy-tips">提示：购买成功后高考年份不可修改，请确认无误后购买！</el-row>
            </el-row> -->
            <h3>支付方式</h3>
            <el-row>
                <el-col :span="7" v-for="(item,index) in typeList" :key="index" :class="activeIndex == index?'active-type':''" @click.native="changePayType(index)">
                    <el-row class="buy-type-infor">
                        <el-col :span="7">
                            <img :src="item.src" :alt="item.name" class="buy-type-wechat">
                        </el-col>
                        <el-col :span="13" class="buy-type-text">
                            {{item.name}}
                        </el-col>
                        <el-col :span="4">
                            <img src="../../assets/images/xz.png" alt="选中" class="buy-type-select" v-if="activeIndex == index">
                            <img src="../../assets/images/dxk.png" alt="未选中" class="buy-type-select" v-else>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="buy-line"></el-row>
            <el-row>
                <el-row class="pay-vip-fee"><span>应付金额：<span>¥{{vipInfor.present_price}}</span></span></el-row>
                <el-row class="pay-vip-fee" v-if="vipInfor.present_price - vipInfor.paid_price > 0"><span>已开通VIP：<span>-¥{{ parseFloat(vipInfor.price - vipInfor.paid_price).toFixed(2) }}</span></span></el-row>
                <el-row class="pay-vip-coupon" v-if="vipInfor.coupon.length > 0">
                    <span @click="showCouponListHandler" style="cursor:pointer">
                        <span v-if="activeCouponIndex === ''">您有{{ vipInfor.coupon.length }}张优惠券可用</span>
                        <span v-else>优惠券：-¥{{couponInfor.coupon_price}}</span>
                        <i class="el-icon-arrow-down" v-if="!showCouponStatus"></i>
                        <i class="el-icon-arrow-up" v-if="showCouponStatus"></i>
                    </span>
                    <el-row class="vip-coupon-box" v-if="showCouponStatus">
                        <el-row class="coupon-content" v-for="(item,index) in vipInfor.coupon" :key="index" :class="activeCouponIndex === index ? 'coupon-content-active' : ''" @click.native="changeSelectCouponHandler(item,index)">
                            <el-col :span="6">
                                <img src="../../assets/images/coupon.png" alt="优惠券">
                                <el-row class="vip-coupon-box-fee">
                                    <span>￥</span>{{ item.coupon_price }}
                                </el-row>
                            </el-col>
                            <el-col :span="16">
                                <div class="coupon-infor">{{ item.name }}</div>
                                <div class="coupon-desc">使用规则：{{ item.coupon_desc ? item.coupon_desc: '无' }}</div>
                                <div class="coupon-desc">使用期限：有效期至{{ item.expire_time }}</div>
                            </el-col>
                            <el-col :span="2">
                                <img src="../../assets/images/xz.png" alt="选中" class="buy-type-select" v-if="activeCouponIndex === index">
                                <img src="../../assets/images/dxk.png" alt="未选中" class="buy-type-select" v-else>
                            </el-col>
                        </el-row>
                    </el-row> 
                </el-row>
                <el-row class="pay-vip-coupon" v-else>
                    优惠券：无 
                </el-row>
                <el-row class="pay-vip-fee1">实付金额：<span class="pay-vip-fee1-icon">¥</span><span class="pay-vip-fee1-count">{{couponInfor.coupon_price?parseFloat(vipInfor.paid_price-couponInfor.coupon_price).toFixed(2):vipInfor.paid_price}}</span></el-row>
                <el-row class="pay-vip-btn">
                    <span>点击立即支付代表您已同意<a href="#">《{{ website.name ? website.name : '荔枝生涯' }}服务协议》</a></span>
                    <el-button @click="payVipHandler">立即支付</el-button>
                </el-row>
            </el-row>
        </div>
        <div v-html="aliPay" ref="alipayWap"></div>
    </div>
</template>

<script>
import { createOrder } from '@/api/pay'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            typeList: [
                {src: require('../../assets/images/wechat.png'),name: '微信支付',pay_type: 'wx'},
                {src: require('../../assets/images/zfb.png'),name: '支付宝支付',pay_type: 'ali'},
            ],
            activeIndex: 0,
            ruleForm: {
                exam_year: ''
            },
            yearList: [],
            default_year: '',
            vipInfor: {
            },
            couponInfor: {
                id: ''
            },
            wechatPay: {},
            activeCouponIndex: '',
            showCouponStatus: false,
            aliPay: ''
        }
    },
    computed: {
        ...mapState({
            website: state => state.user.website
        })
    },
    created () {
        this.vipInfor = this.$route.params.product;
        this.showSelectYearHandler();
    },
    methods: {
        showSelectYearHandler() {
            let date = new Date();
            let yearList = [];
            for (let i = 0; i < 3; i++) {
                if(date.getMonth() > 7) {
                    yearList.push(date.getFullYear() + i + 1);
                } else {
                    yearList.push(date.getFullYear() + i);
                }
            }
            this.default_year = yearList[0]
            this.yearList = [...yearList];
            // if(date.getMonth() > 7) {
            //     this.ruleForm.exam_year = date.getFullYear() + 1;
            // } else {
            //     this.ruleForm.exam_year = date.getFullYear();
            // }
        },
        changePayType(index) {
            this.activeIndex = index
        },
        payVipHandler() {
            // if(!this.ruleForm.exam_year && this.vipInfor.is_choose_year == '1') {
            //     this.$message({
            //         message: '请选择高考年份',
            //         type: 'warning'
            //     })
            //     return
            // }
            // if(this.vipInfor.is_choose_year == '0') {
            //     this.ruleForm.exam_year = this.default_year
            // }
            createOrder(this.vipInfor.id,this.couponInfor.id,this.typeList[this.activeIndex].pay_type,this.ruleForm.exam_year).then(res => {
                if(this.activeIndex == 0) {
                    this.wechatPay.title = this.vipInfor.title
                    this.wechatPay.qr_code = res.data.qr_code
                    this.wechatPay.order_no = res.data.order_no
                    this.wechatPay.fee = this.couponInfor.coupon_price?parseFloat(this.vipInfor.paid_price-this.couponInfor.coupon_price).toFixed(2):this.vipInfor.paid_price
                    this.$store.commit('user/QRCODE',this.wechatPay)
                    this.$store.commit('user/SHOWWECHAT', true)
                } else {
                    this.aliPay = res;
                    this.$nextTick(() => {
                        this.$refs.alipayWap.children[0].submit()
                    })
                }
            })
        },
        changeSelectCouponHandler(item,index) {
            this.activeCouponIndex = index
            this.couponInfor = item
            this.showCouponStatus = !this.showCouponStatus
        },
        showCouponListHandler() {
            this.showCouponStatus = !this.showCouponStatus
        }
    }
}
</script>

<style scpoed lang="scss">
@import "@/assets/css/variables.scss";
.buy-box-content {
    @include gwidth;
    min-height: 830px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
    margin-top: 24px;
    padding: 24px;
    box-sizing: border-box;
    h3 {
        font-size: 20px;
        font-weight: 600;
        color: #2c2e33;
        margin: 0;
        padding-bottom: 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #f0f2f5;
    }
    .buy-vip-infor {
        height: 240px;
        background: #f5f7fa;
        border-radius: 10px;
        padding: 32px 32px 32px 48px;
        box-sizing: border-box;
        margin-bottom: 32px;
        margin-top: 24px;
        .el-col-18 {
            padding-left: 30px;
        }
        img {
            width: 254px;
            height: 160px;
        }
        .buy-vip-title {
            font-size: 32px;
            font-weight: 600;
            color: #2c2e33;
            span {
                color: #FFAD1E;
            }
        }
        .buy-vip-title-diff {
            color: #7F16A7!important;
        }
        .buy-vip-money {
            text-align: right;
            font-size: 24px;
            font-weight: 400;
            color: #ee4444;
            span {
                font-size: 18px;
                font-weight: 400;
                position: relative;
                top: -1px;
            }
        }
        .buy-vip-desc {
            color: #2C2E33;
            font-size: 16px;
            font-weight: 400;
            margin-top: 64px;
            line-height: 30px;
            span {
                color: #909399;
            }
        }
    }
    .buy-type-infor {
        width: 290px;
        height: 88px;
        line-height: 48px;
        background: #ffffff;
        border: 1px solid #ebedf0;
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;
        margin-top: 32px;
        .buy-type-wechat {
            width: 48px;
            height: 48px;
        }
        .buy-type-select {
            width: 20px;
            height: 20px;
            float: right;
            position: relative;
            top: 16px;
        }
        .buy-type-text {
            color: #2c2e33;
            font-size: 18px;
            font-weight: 400;
        }
    }
    .active-type {
        .buy-type-infor {
            border: 1px solid $common-color;
            background: #fff7f4;
        }
        .buy-type-text {
            color: $common-color;
        }
    }
    .buy-line {
        margin-top: 40px;
        margin-bottom: 32px;
        border-top: 1px solid #f0f2f5;
    }
    .pay-vip-fee {
        color: #5e6166;
        font-weight: 400;
        font-size: 16px;
        text-align: right;
    }
    .pay-vip-fee1 {
        text-align: right;
        font-size: 16px;
        font-weight: 400;
        color: #5e6166;
        margin-top: 18px;
        .pay-vip-fee1-icon {
            color: #EE4444;
            font-size: 16px;
        }
        .pay-vip-fee1-count {
            color: #EE4444;
            font-size: 42px;
        }
    }
    .pay-vip-coupon {
        font-size: 16px;
        font-weight: 400;
        color: #ff7721;
        text-align: right;
        margin-top: 8px;
        .el-icon-arrow-down {
            color: #c4c7cc !important;
            margin-left: 4px;
        }
        .el-icon-arrow-up {
            margin-left: 4px;
        }
    }
    .pay-vip-btn {
        text-align: right;
        margin-top: 25px;
        span {
            font-size: 16px;
            font-weight: 400;
            color: #5e6166;
        }
        a {
            text-decoration: none;
            color: $common-color;  
        }
        button {
            width: 152px!important;
            height: 52px!important;
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            border-radius: 8px!important;
            border: none!important;
            margin-left: 20px;
            span {
                color: #ffffff!important;
                font-size: 18px!important;
                font-weight: 600!important;
                text-align: center!important;
            }
        }
    }
    .buy-form {
        margin-top: 24px; 
        margin-bottom: 32px; 
    }
    .buy-desc {
        font-size: 16px;
        font-weight: 400;
        color: #909399;
        line-height: 22px;
    }
    .buy-date {
        color: #2c2e33;
        font-size: 18px;
        font-weight: 500;
        margin-top: 5px;
    }
    .buy-tips {
        font-size: 16px;
        font-weight: 400;
        color: #ff7721;
    }
}   .vip-coupon-box {
        position: absolute;
        width: 596px;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.10); 
        padding: 20px 20px 15px 20px;
        box-sizing: border-box;
        right: 0;
        bottom: 30px;
        .coupon-content {
            height: 116px;
            padding: 21px 16px;
            width: 556px;
            height: 116px;
            background: #f5f7fa;
            border-radius: 8px;
            margin-bottom: 12px;
        }
        .el-col-16 {
            padding-left: 25px;
            text-align: left;
        }
        img {
            width: 133px;
            height: 74px;
            position: relative;
        }
        .vip-coupon-box-fee {
            color: #ffffff;
            font-size: 24px;
            // font-weight: 600;
            position: absolute;
            top: 44px;
            left: 20px;
            span {
                font-size: 16px!important; 
                color: #ffffff!important;
            }
        }
        .coupon-infor {
            color: #2c2e33;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 16px;
            span {
                color: #EE4444;
            }
        }
        .coupon-desc {
            color: #909399;
            font-size: 14px;
            font-weight: 400;
            margin-top: 6px;
        }
        .buy-type-select {
            width: 20px;
            height: 20px;
            float: right;
            position: relative;
            top: 28px;
        }
        .coupon-content-active {
            background: #fff1eb;
        }
    }
</style>